module.exports = __webpack_public_path__ + "3e303f7f120428c7caf219d1d3c8596a.svg";